// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"30ffe06c","143":"cbe1948d","144":"c157a0d6","494":"626250a4","533":"02065213","651":"36eb4f5a","690":"26180ecf","852":"928e4d59","940":"b93e0e6e"}[chunkId] + ".chunk.js";
};